import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators
} from '@angular/forms';
import { ClientField } from '../../../domain/models';

export class PersonalInformationForm {
    private static _fb: UntypedFormBuilder;

    static initialize(fb: UntypedFormBuilder): UntypedFormGroup {
        this._fb = fb;
        let formGroup = fb.group({
            applicationId: [undefined, Validators.required]
        });
        formGroup.addValidators(this.atLeastOnePhoneFormValidator);
        formGroup.addValidators(
            this.consentTextMessageWhenCellPhoneSelectedFormValidator
        );
        formGroup.addValidators(this.computerEquipmentRequiredValidator);
        return formGroup;
    }

    static setFields(fields: ClientField[], formGroup: UntypedFormGroup): void {
        fields.forEach((field) => {
            switch (field.fieldName) {
                case 'BirthDate':
                    formGroup.addControl(
                        'birthDate',
                        this._fb.control(undefined, [
                            this.minimumAgeValidator(16),
                            this.maximumAgeValidator(100)
                        ])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('birthDate')
                            ?.addValidators([Validators.required]);
                    break;
                case 'AgeAtEnrollment':
                    formGroup.addControl(
                        'ageAtEnrollment',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('ageAtEnrollment')
                            ?.addValidators([Validators.required]);
                    break;
                case 'FirstName':
                    formGroup.addControl(
                        'firstName',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('firstName')
                            ?.addValidators([Validators.required]);
                    break;
                case 'MiddleName':
                    formGroup.addControl(
                        'middleName',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('middleName')
                            ?.addValidators([Validators.required]);
                    break;
                case 'LastName':
                    formGroup.addControl(
                        'lastName',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('lastName')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Suffix':
                    formGroup.addControl('suffix', this._fb.control(undefined));
                    if (field.isRequired)
                        formGroup
                            ?.get('suffix')
                            ?.addValidators([Validators.required]);
                    break;
                case 'OtherNames':
                    formGroup.addControl(
                        'otherNames',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('otherNames')
                            ?.addValidators([Validators.required]);
                    break;
                case 'HasSocialSecurityNumber':
                    formGroup.addControl(
                        'hasSocialSecurityNumberSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('hasSocialSecurityNumberSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'SocialSecurityNumber':
                    formGroup.addControl(
                        'socialSecurityNumber',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('socialSecurityNumber')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Sex':
                    formGroup.addControl(
                        'sexSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('sexSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'SexBinary':
                    formGroup.addControl(
                        'sexBinarySelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('sexBinarySelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'GenderIdentity':
                    formGroup.addControl(
                        'genderIdentitySelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('genderIdentitySelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Pronouns':
                    formGroup.addControl(
                        'pronounsSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('pronounsSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ContactPreference':
                    formGroup.addControl(
                        'contactPreferenceSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('contactPreferenceSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'CanContactByText':
                    formGroup.addControl(
                        'canContactByTextSelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('canContactByTextSelectionId')
                            ?.addValidators([Validators.required]);
                    break;
                case 'MobilePhone':
                    formGroup.addControl(
                        'mobilePhone',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('mobilePhone')
                            ?.addValidators([Validators.required]);
                    break;
                case 'HomePhone':
                    formGroup.addControl(
                        'homePhone',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('homePhone')
                            ?.addValidators([Validators.required]);
                    break;
                case 'WorkPhone':
                    formGroup.addControl(
                        'workPhone',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('workPhone')
                            ?.addValidators([Validators.required]);
                    break;
                case 'Email':
                    formGroup.addControl(
                        'email',
                        this._fb.control(undefined, [
                            Validators.email,
                            this.emailRequiredValidator(formGroup)
                        ])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('email')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ConsentReceiveTextMessage':
                    formGroup.addControl(
                        'consentReceiveTextMessage',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('consentReceiveTextMessage')
                            ?.addValidators([Validators.required]);
                    break;
                case 'SecondaryEmail':
                    formGroup.addControl(
                        'secondaryEmail',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('secondaryEmail')
                            ?.addValidators([Validators.required]);
                    break;
                case 'MailingStreetAddress':
                    PersonalInformationForm.configureAddressField(
                        formGroup,
                        'streetAddress'
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('mailingAddress')
                            ?.get('streetAddress')
                            ?.addValidators([Validators.required]);
                    break;
                case 'MailingAptSuiteOther':
                    PersonalInformationForm.configureAddressField(
                        formGroup,
                        'aptSuiteOther'
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('mailingAddress')
                            ?.get('aptSuiteOther')
                            ?.addValidators([Validators.required]);
                    break;
                case 'MailingCity':
                    PersonalInformationForm.configureAddressField(
                        formGroup,
                        'city'
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('mailingAddress')
                            ?.get('city')
                            ?.addValidators([Validators.required]);
                    break;
                case 'MailingStateCode':
                    PersonalInformationForm.configureAddressField(
                        formGroup,
                        'stateCode'
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('mailingAddress')
                            ?.get('stateCode')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ResidenceArea':
                    formGroup.addControl(
                        'residenceAreaCode',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('residenceAreaCode')
                            ?.addValidators([Validators.required]);
                    break;
                case 'MailingPostalCode':
                    PersonalInformationForm.configureAddressField(
                        formGroup,
                        'postalCode'
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('mailingAddress')
                            ?.get('postalCode')
                            ?.addValidators([Validators.required]);
                    break;
                case 'MailingCounty':
                    PersonalInformationForm.configureAddressField(
                        formGroup,
                        'county'
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('mailingAddress')
                            ?.get('county')
                            ?.addValidators([Validators.required]);
                    break;
                case 'EmergencyContactName':
                    formGroup.addControl(
                        'emergencyContactName',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('emergencyContactName')
                            ?.addValidators([Validators.required]);
                    break;
                case 'EmergencyContactPhone':
                    formGroup.addControl(
                        'emergencyContactPhone',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('emergencyContactPhone')
                            ?.addValidators([Validators.required]);
                    break;
                case 'EmergencyContactRelationship':
                    formGroup.addControl(
                        'emergencyContactRelationship',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('emergencyContactRelationship')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ComputerEquipment':
                    formGroup?.addControl(
                        'computerEquipmentSelectionIds',
                        this._fb.control([])
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('computerEquipmentSelectionIds')
                            ?.addValidators([Validators.required]);
                    break;
                case 'ComfortUsingTechnology':
                    formGroup?.addControl(
                        'comfortUsingTechnologySelectionId',
                        this._fb.control(undefined)
                    );
                    if (field.isRequired)
                        formGroup
                            ?.get('comfortUsingTechnologySelectionId')
                            ?.addValidators([Validators.required]);
                    break;
            }
        });
    }

    private static configureAddressField(
        formGroup: UntypedFormGroup,
        controlName: string,
        defaultValue: '' | undefined | [] = ''
    ) {
        // using contains instead of get because when a form group is checked
        // via `get` an error is thrown about it not being there.  Switching to
        // contains also makes more sense considering we are checking to see if
        // it exists, not necessarily to get an instance reference to it.
        if (!formGroup.contains('mailingAddress')) {
            formGroup.addControl('mailingAddress', this._fb.group({}));
            (<UntypedFormGroup>formGroup.get('mailingAddress')).addControl(
                'addressId',
                this._fb.control(undefined)
            );
        }
        (<UntypedFormGroup>formGroup.get('mailingAddress')).addControl(
            controlName,
            this._fb.control(defaultValue)
        );
    }

    static calculateAge(date: any): Number | null {
        const { calculateAge } = require('../../../core/helpers') as {
            calculateAge: (d: any) => number | null;
        };
        return calculateAge(date);
    }

    private static emailRequiredValidator(
        formGroup: UntypedFormGroup
    ): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const required =
                formGroup?.value?.contactPreferenceSelectionId === 18;
            return required && control.value === '' ? { required: true } : null;
        };
    }

    private static minimumAgeValidator(minimumAge: Number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let age = this.calculateAge(control);
            if (age === null) return null;
            const minimumAgeMet = age >= minimumAge;
            return !minimumAgeMet ? { minimumAge: true } : null;
        };
    }

    private static maximumAgeValidator(maximumAge: Number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            let age = this.calculateAge(control);
            if (age === null) return null;
            const maximumAgeMet = age < maximumAge;
            return !maximumAgeMet ? { maximumAge: true } : null;
        };
    }

    private static atLeastOnePhoneFormValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        const mobilePhone = control.get('mobilePhone')?.value ?? '';
        const homePhone = control.get('homePhone')?.value ?? '';
        const workPhone = control.get('workPhone')?.value ?? '';
        if (mobilePhone === '' && homePhone === '' && workPhone === '')
            return { atLeastOnePhoneRequired: true };
        return null;
    }

    private static consentTextMessageWhenCellPhoneSelectedFormValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        const controlConsentReceiveTextMessage = control.get(
            'consentReceiveTextMessage'
        );

        const contactPreference =
            control.get('contactPreferenceSelectionId')?.value ?? '';
        const consentReceiveTextMessage =
            controlConsentReceiveTextMessage?.value;

        if (
            controlConsentReceiveTextMessage &&
            (contactPreference === 17 || contactPreference === 19) &&
            consentReceiveTextMessage !== 1
        )
            return { consentTextMessageRequired: true };

        return null;
    }

    private static computerEquipmentRequiredValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        const computerEquipment = control.get(
            'computerEquipmentSelectionIds'
        )?.value;

        if (
            computerEquipment &&
            computerEquipment.length > 1 &&
            computerEquipment.includes(454)
        ) {
            return { computerEquipmentNoneInvalid: true };
        }
        return null;
    }
}
